/** Local imports */

import {reducer as cachedMedia} from '~/common/reducers/cachedMedia';
import {reducer as favorites} from './favorites';
import {reducer as filters} from './filters';
import {reducer as galleryData} from './galleryData';

export const rootReducer = {
  galleryData,
  favorites,
  filters,
  cachedMedia,
};
